import React from "react";
import { Form, Row, Col, Input, Button, message, Space } from "antd";
import { taxTypeService } from "_services/taxType.service";

function Search({ onSearchResults, showSearchLoading }) {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    showSearchLoading(true);
    let searchParams = [];

    if (values.code) {
      searchParams.push(`code=${encodeURIComponent(values.code)}`);
    }

    if (values.name) {
      searchParams.push(`name=${encodeURIComponent(values.name)}`);
    }

    const queryString = searchParams.length ? `?${searchParams.join("&")}` : "";

    taxTypeService
      .search(queryString)
      .then((data) => {
        showSearchLoading(false);
        onSearchResults(data.content);
      })
      .catch((error) => {
        message.error(`${error}`);
        showSearchLoading(false);
        onSearchResults([]);
      });
  };

  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        className="search-form"
      >
        <Row gutter={24}>
          <Col span={6}>
            <Form.Item name={["code"]} label="Code">
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name={["name"]} label="Name">
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col span={8}></Col>

          <Col span={4}>
            <Col span={4} style={{ textAlign: "right" }}>
              <Space direction="horizontal">
                <Button type="primary" htmlType="submit">
                  Search
                </Button>
                <Button
                  style={{ margin: "0 8px" }}
                  onClick={() => {
                    onFinish({});
                    form.resetFields();
                  }}
                >
                  Clear
                </Button>
              </Space>
            </Col>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default Search;
